import { render, staticRenderFns } from "./DashboardMobileLayout.vue?vue&type=template&id=25c44664&scoped=true"
import script from "./DashboardMobileLayout.vue?vue&type=script&lang=js"
export * from "./DashboardMobileLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c44664",
  null
  
)

export default component.exports